module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "VPS-xiv"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "fmt"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("List of Tables")])]), _vm._v(" "), _c('p', {
    staticClass: "map1"
  }, [_vm._v("Table 1.1 Losses of the Central Powers During WWI, Austria–Hungary")]), _vm._v(" "), _c('p', {
    staticClass: "map1"
  }, [_vm._v("Table 1.2 Ethnic Composition of the Kingdom of Hungary’s Population, Prior to and After World War I")]), _vm._v(" "), _c('p', {
    staticClass: "map1"
  }, [_vm._v("Table 2.1 Order of Battle of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Honvédség")]), _vm._v(", June 1941–April 1942")]), _vm._v(" "), _c('p', {
    staticClass: "map1"
  }, [_vm._v("Table 2.2 Organization of Army Corps in 1941")]), _vm._v(" "), _c('p', {
    staticClass: "map1"
  }, [_vm._v("Table 2.3 Organization of Infantry Brigade in 1941")]), _vm._v(" "), _c('p', {
    staticClass: "map1"
  }, [_vm._v("Table 2.4 Organization of Mountain Brigade in 1941")]), _vm._v(" "), _c('p', {
    staticClass: "map1"
  }, [_vm._v("Table 2.5 Organization of Motorized Brigade in 1941")]), _vm._v(" "), _c('p', {
    staticClass: "map1"
  }, [_vm._v("Table 2.6 Organization of Cavalry Brigade in 1941")]), _vm._v(" "), _c('p', {
    staticClass: "map1"
  }, [_vm._v("Table 2.7 Armoured Vehicles Ordered According to the Huba III Plan")]), _vm._v(" "), _c('p', {
    staticClass: "map1"
  }, [_vm._v("Table 2.8 Artillery pieces used by the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Honvédség")]), _vm._v("’s field artillery units in 1943")]), _vm._v(" "), _c('p', {
    staticClass: "map1"
  }, [_vm._v("Table 2.9 Armoured Vehicles Required vs. Manufactured")]), _vm._v(" "), _c('p', {
    staticClass: "map1"
  }, [_vm._v("Table 2.10 Authorized Amount of Weapons of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Honvédség")]), _vm._v(" Infantry Divisions, 1943–1945")]), _vm._v(" "), _c('p', {
    staticClass: "map1"
  }, [_vm._v("Table 2.11 Organization of Szabolcs I and II Infantry Divsions")]), _vm._v(" "), _c('p', {
    staticClass: "map1"
  }, [_vm._v("Table 2.12 Organization of the Mountain Brigade (March 1944)")]), _vm._v(" "), _c('p', {
    staticClass: "map1"
  }, [_vm._v("Table 2.13 Comparison of the Organizations of 1943 and 1944 Armoured Divisions")]), _vm._v(" "), _c('p', {
    staticClass: "map1"
  }, [_vm._v("Table 2.14 Comparison of the Organizations of 1943 and 1944 Cavalry Divisions")]), _vm._v(" "), _c('p', {
    staticClass: "map1"
  }, [_vm._v("Table 3.1 The Final Production Figures of Turán I")]), _vm._v(" "), _c('p', {
    staticClass: "map1"
  }, [_vm._v("Table 3.2 Monthly Turán I Production Figures")]), _vm._v(" "), _c('p', {
    staticClass: "map1"
  }, [_vm._v("Table 3.3 The Final Production Figures of Turán II")]), _vm._v(" "), _c('p', {
    staticClass: "map1"
  }, [_vm._v("Table 3.4 Monthly Turán II Production Figures")]), _vm._v(" "), _c('p', {
    staticClass: "map1"
  }, [_vm._v("Table 3.5 Zrínyi II Production Figures")]), _vm._v(" "), _c('p', {
    staticClass: "map1"
  }, [_vm._v("Table 3.6 List of armoured fighting vehicles received by the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Honvédség")]), _vm._v(", 1939–1945")]), _vm._v(" "), _c('p', {
    staticClass: "map1"
  }, [_vm._v("Table 3.7 German armour deliveries to the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Honvédség")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a86f826","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/tables.vue
// module id = 84
// module chunks = 0